import { c as _c } from "react/compiler-runtime";
// The white wave that fades the bottom of every city card. Defined once as an
// SVG <symbol> and referenced with <use> from each card: as an inline <svg>
// per card (the old wave.svg component) it was ~750 bytes of path data
// twenty-five times over, in the HTML and again in the RSC payload.
const WAVE_SYMBOL_ID = 'cityGalleryWave';
const WAVE_PATH_BACK = 'M 0,400 L 0,100 C 112.8133971291866,124.07655502392345 225.6267942583732,148.1531100478469 310,136 C 394.3732057416268,123.8468899521531 450.3062200956938,75.4641148325359 530,72 C 609.6937799043062,68.5358851674641 713.1483253588518,109.99043062200955 815,116 C 916.8516746411482,122.00956937799045 1017.1004784688994,92.57416267942584 1121,84 C 1224.8995215311006,75.42583732057416 1332.4497607655503,87.71291866028707 1440,100 L 1440,400 L 0,400 Z';
const WAVE_PATH_FRONT = 'M 0,400 L 0,233 C 114.06698564593302,212.9043062200957 228.13397129186603,192.80861244019138 320,185 C 411.86602870813397,177.19138755980862 481.53110047846906,181.66985645933013 570,207 C 658.468899521531,232.33014354066987 765.7416267942583,278.511961722488 873,270 C 980.2583732057417,261.488038277512 1087.5023923444976,198.2822966507177 1182,183 C 1276.4976076555024,167.7177033492823 1358.248803827751,200.35885167464113 1440,233 L 1440,400 L 0,400 Z';
export function WaveSymbolDefinition() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "absolute"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <svg width="0" height="0" style={t0} aria-hidden="true" focusable="false"><defs><symbol id={WAVE_SYMBOL_ID} viewBox="0 0 1440 290"><path d={WAVE_PATH_BACK} fill="#ffffff" fillOpacity="0.53" /><path d={WAVE_PATH_FRONT} fill="#ffffff" /></symbol></defs></svg>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export function WaveSymbolUse() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="100%" height="100%" viewBox="0 0 1440 290" aria-hidden="true" focusable="false"><use href={`#${WAVE_SYMBOL_ID}`} /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}